import {createRouter, createWebHashHistory} from 'vue-router';

import {useAuthStore} from "@/stores/auth.store";
import {EPermissao} from "@/stores/enums/EPermissao";
import AppLayout from "@/layout/AppLayout.vue";
import {useHomeStore} from "@/stores/home.store";
import {useAppHelper} from "@/helpers/app.helper";

const {checkForUpdate} = useAppHelper();


const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: "/signin",
            name: "signin",
            meta: {authRequired: false},
            component: () => import('@/views/pages/signin/PageSignin.vue')
        },
        {
            path: "/usuario/recuperacao-senha/:solicitacaoId",
            meta: {authRequired: false},
            component: () => import('@/views/pages/signin/PageRecuperacaoSenha.vue')
        },
        {
            path: "/teste",
            meta: {authRequired: true},
            component: () => import('@/views/pages/teste/TesteComponent.vue')
        },
        {
            path: '/',
            component: AppLayout,
            children: [
                {
                    path: '/',
                    name: 'home',
                    meta: {authRequired: true},
                    component: () => import('@/views/pages/home/PageHome.vue')
                },
                {
                    path: '/permissao_negada',
                    name: 'permissao_negada',
                    component: () => import("@/layout/layoutPages/PagePermissaoNegada.vue")

                },
                {
                    path: '/perfil',
                    name: 'perfil',
                    meta: {authRequired: true},
                    component: () => import('@/views/pages/perfil/PagePerfil.vue')
                },
                {
                  path: "/autorizacao",
                  name: "autorizacao_acao",
                  meta: {authRequired: true},
                  component: ()=> import('@/views/pages/autorizacao/PageAutorizacaoAcao.vue')
                },
                //#SEÇÃO ADMIN
                {
                    path: '/empresas',
                    name: 'empresas',
                    meta: {authRequired: true, permissao: EPermissao.ADMIN_EMPRESAS},
                    component: () => import('@/views/pages/empresa/PageEmpresas.vue')

                },

                {
                    path: '/colaboradores',
                    name: 'colaboradores',
                    meta: {authRequired: true, permissao: EPermissao.ADMIN_COLABORADORES},
                    component: () => import('@/views/pages/colaborador/PageColaboradores.vue')
                },
                //SUBMENU LOJA
                {
                    path: '/comissoes',
                    name: 'comissoes',
                    meta: {authRequired: true, permissao: EPermissao.ADMIN_LOJA_COMISSAO},
                    component: () => import('@/views/pages/comissao/PageComissao.vue')
                },

                {
                    path: '/empresaDescontos',
                    name: 'empresaDescontos',
                    meta: {authRequired: true, permissao: EPermissao.ADMIN_LOJA_DESCONTO},
                    component: () => import('@/views/pages/desconto/PageEmpresaDesconto.vue')
                },
                {
                    path: '/metasVendas',
                    name: 'metasVendas',
                    meta: {authRequired: true, permissao: EPermissao.ADMIN_LOJA_METASVENDA},
                    component: () => import('@/views/pages/metaVenda/PageMetaVenda.vue')
                },


                //#SUBMENU CADASTRO
                {
                    path: '/grupoPermissao',
                    name: 'grupoPermissao',
                    meta: {authRequired: true, permissao: EPermissao.ADMIN_CADASTRO_GRUPOPERMISSAO},
                    component: () => import('@/views/pages/grupoPermissao/PageGrupoPermissao.vue')
                },
                {
                    path: '/planoSeguro',
                    name: 'planoSeguro',
                    meta: {authRequired: true, permissao: EPermissao.ADMIN_CADASTRO_PLANOSEGURO},
                    component: () => import('@/views/pages/planoSeguro/PagePlanoSeguro.vue')
                },
                {
                    path: '/comissoes',
                    name: 'comissoes',
                    meta: {authRequired: true, permissao: EPermissao.ADMIN_LOJA_COMISSAO},
                    component: () => import('@/views/pages/comissao/PageComissao.vue')
                },
                {
                    path: '/metasVendas',
                    name: 'metasVendas',
                    meta: {authRequired: true, permissao: EPermissao.ADMIN_LOJA_METASVENDA},
                    component: () => import('@/views/pages/metaVenda/PageMetaVenda.vue')
                },
                {
                    path: '/tarifas',
                    name: 'tarifas',
                    meta: {authRequired: true, permissao: EPermissao.ADMIN_LOJA_TARIFA},
                    component: () => import('@/views/pages/formaPagamento/PageFormaPagamentoTarifa.vue')
                },
                //#SEÇÃO OPERAÇÃO
                {
                    path: '/vendas',
                    name: 'vendas',
                    meta: {authRequired: true, permissao: EPermissao.OPERACAO_VENDA},
                    component: () => import('@/views/pages/venda/PageVenda.vue')
                },

                {
                    path: '/clientes',
                    name: 'clientes',
                    meta: {authRequired: true, permissao: EPermissao.OPERACAO_CLIENTE},
                    component: () => import('@/views/pages/cliente/PageCliente.vue')
                },
                {
                    path: '/seguros',
                    name: 'seguros',
                    meta: {authRequired: true, permissao: EPermissao.OPERACAO_SEGURO},
                    component: () => import('@/views/pages/seguro/PageSeguro.vue')
                },
                {
                    path: '/sinistros',
                    name: 'sinistros',
                    meta: {authRequired: true, permissao: EPermissao.OPERACAO_SINISTRO},
                    component: () => import('@/views/pages/sinistro/PageSinistro.vue')
                },

                //#SEÇÃO FINANCEIRO

                {
                    path: '/lancamentos',
                    name: 'lancamentos',
                    meta: {authRequired: true, permissao: EPermissao.FINANCEIRO_LANCAMENTO},
                    component: () => import('@/views/pages/lancamento/PageLancamento.vue')
                },
                //#SEÇÃO RELATÓRIOS

                {
                    path: '/relatorio/comissao',
                    name: 'relatorio_comissao',
                    meta: {authRequired: true, permissao: EPermissao.RELATORIO_COMISSAO_VISUALIZAR_RELATORIO},
                    component: () => import("@/views/pages/relatorio/PageRelatorioComissao.vue")
                },


                {
                    path: '/relatorio/produto/vendido',
                    name: 'relatorio_produto_vendido',
                    meta: {authRequired: true, permissao: EPermissao.RELATORIO_PRODUTOVENDIDO},
                    component: () => import("@/views/pages/relatorio/PageRelatorioProdutoVendido.vue")
                },


                {
                    path: '/relatorio/dre',
                    name: 'relatorio_dre',
                    meta: {authRequired: true, permissao: EPermissao.RELATORIO_DRE_FORMAPAGAMENTO},
                    component: () => import("@/views/pages/relatorio/PageRelatorioDre.vue")
                },
                {
                    path: '/relatorio/fechamentoVendedor',
                    name: 'relatorio_fechamento_vendedor',
                    meta: {authRequired: true, permissao: EPermissao.RELATORIO_FECHAMENTOVENDEDOR},
                    component: () => import("@/views/pages/relatorio/PageRelatorioFechamentoVendedor.vue")
                },
                {
                    path: '/relatorio/ranking/loja/ps',
                    name: 'relatorio_ranking_loja_ps',
                    meta: {authRequired: true, permissao: EPermissao.RELATORIO_RANKINGLOJA},
                    component: () => import("@/views/pages/relatorio/PageRelatorioRankingLojaPs.vue")
                },
                {
                    path: '/relatorio/metas',
                    name: 'relatorio_metas',
                    meta: {authRequired: true, permissao: EPermissao.RELATORIO_METASVENDA_VISUALIZAR_RELATORIO},
                    component: () => import("@/views/pages/relatorio/PageRelatorioMeta.vue")
                },
                {
                    path: '/relatorio/metas/colaborador',
                    name: 'relatorio_metas_colaborador',
                    meta: {authRequired: true, permissao: EPermissao.RELATORIO_METASCOLABORADOR},
                    component: () => import("@/views/pages/relatorio/PageRelatorioMetaColaborador.vue")
                },


            ]
        },


    ]
});

router.beforeEach(async (to, from, next) => {

    const homeStore = useHomeStore();
    homeStore.isShowPaceLoading = true;
    const authStore = useAuthStore();
    const authRequired = (!to.meta ? true : to.meta.authRequired);


    //Verifica se a rota precisa de autenticação
    if (!authRequired) {
        //Se não precisar, redireciona para a rota solicitada
        return next();

    } else {

        //A partir daqui, a rota precisa de autorização
        //Verifica se o usuário está logado através da store isLoggedIn e Permissoes

        if (!(authStore.isLoggedIn() && authStore.usuarioPermissoes)) {
            //Nao esta logado ou não tem permissao

            //Se não tiver logado direciona para o login
            if (!authStore.isLoggedIn()) {
                authStore.sair();
                next('/signin')
            } else {

                //Aciona o método que verifica se o usuário está ativo, por meio da sessão ou token válido
                if (!(await authStore.verificarUsuarioAtivo())) {
                    //Se não conseguiu verificar o usuario ou usuario não ativo, direciona para o login
                    authStore.sair();
                    next('/signin')
                }
            }

        }
        //fim da verificação do usuario logado

        //Verifica se a rota precisa de permissão
        if (to.meta.permissao) {
            //precisa
            //Verifica se o usuário possui a permissão solicitada pela rota
            if (authStore.temPermissao(to.meta.permissao as EPermissao)) {
                //tem = continua para rota solicitada
                return next();

            } else {
                //não tem = direciona para pagina de acesso negado
                return next('/permissao_negada');
            }
        } else {
            //não precisa = continua para rota solicitada
            return next();
        }


    }

});

router.afterEach(() => {

    const homeStore = useHomeStore();
    homeStore.isShowPaceLoading = false;
    checkForUpdate();
})


export default router;
